import React from "react";

import {
  ALL_CLIENT_WISE_HEADER,
} from "../../../../constant/tableHeadersConstants/UserAndClientWiseOCRReportConst";
import { GetClientOCRReportCountType, GetClientWiseOCRReportListType } from "../../../../redux/listing/listingTypes";
import SingleClientWiseTableData from "./SingleClientWiseTableData";
import ClientWiseTableData from "./ClientWiseTableData";

type AppProps = {
  clientWiseOCRReportList: GetClientWiseOCRReportListType[] | [];
  data: GetClientWiseOCRReportListType[] | [];
  setData: React.Dispatch<
    React.SetStateAction<[] | GetClientWiseOCRReportListType[]>
  >;
  finalUser: string;
  clientWiseOCRReportTotalData :[] |GetClientOCRReportCountType[]
};

const ClientWiseTable = ({
  clientWiseOCRReportList,
  data,
  setData,
  finalUser,
  clientWiseOCRReportTotalData
}: AppProps) => {
  return (
    <div>
      <div className="jobsType" style={{ minHeight: "400px" }}>
        <table className="table thead-light table-bordered" style={{overflowY: "auto"}}>
          <thead className="text-start ">
            {clientWiseOCRReportTotalData?.length? <tr>
              <th>TOTAL</th> 
              <th>{clientWiseOCRReportTotalData[0]?.expense_count}</th>
              <th>{clientWiseOCRReportTotalData[0]?.sales_count}</th>
              <th>{clientWiseOCRReportTotalData[0]?.total_count}</th>
            </tr>:""}
         
            <tr>
              {/* {finalUser === "Select..." ? <th></th> : ""} */}
              <th>{finalUser === "Select..." || finalUser === "All" ? "CLIENT" : "USER"}</th>
              <th>EXPENSES</th>
              <th>SALES</th>
              <th>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {finalUser === "All" || finalUser === "Select..." ? (
              <ClientWiseTableData
                data={data}
                setData={setData}
                tableHeader={ALL_CLIENT_WISE_HEADER}
              />
            ) : (
              <SingleClientWiseTableData
                data={data}
                setData={setData}
                tableHeader={ALL_CLIENT_WISE_HEADER}
              />
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientWiseTable;
